import { FONT_FAMILY } from '../../constants';

export default {
  container: {
    height: '100%',
    overflowY: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    marginLeft: '5%',
  },
  containerMobile: {
    height: 'calc(94vh - 115px)',
    backgroundColor: 'white',
  },
  boardModalTableContainer: {
    overflowY: 'scroll',
    width: '90%',
    maxHeight:'250px',
    marginTop:'1%',
    marginBottom:'2%'
  },
  boardModalTableContainerMobile:{
    width: '100%',
    overflowY: 'scroll',
    maxHeight:'250px',
    marginTop:'1%'
  },
  dropDown3: {
    height: '20px',
    width: '20px',
    marginTop: '8px',
  },

  rightSideMainDiv: {
    height: 'calc(100%)',
    paddingTop: '25px',
    paddingBottom: '30px',
    boxSizing: 'border-box',
    background: '#D3D3D3',
  },
  imageDiv: {
    margin: '0 auto',
    width: '90%',
  },
  imageStyle: {
    width: '100%',
    height: '320px',
  },

  filtermodal: {
    margin: '30px',
    marginTop: '150px',
  },
  filterdivmodal: {
    background: '#fff',
    padding: '20px',
    borderRadius: '10px',
  },

  // Option Trade FilterBar
  checkBoxText: { fontSize: '0.8rem' },
  filterDiv: {
    marginTop: '1%',
  },
  filterIcon: {
    height: '20px',
    width: '20px',
    marginLeft: '5px',
    paddingTop: '4px',
  },
  headingStyle: {
    fontFamily: FONT_FAMILY,
    fontWeight: 'bold',
    marginTop: '2%',
  },
  headingStyleMobile: {
    fontFamily: FONT_FAMILY,
    fontWeight: 'bold',
    marginTop: '2%',
    fontSize: '13px',
  },
  dropDown: {
    height: '20px',
    width: '20px',
    marginTop: '5px',
  },
  filterText: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '1%',
    marginRight: '2%',
  },

  filterTextMobile: { marginTop: '2%', marginLeft: '1%' },
};



// WEBPACK FOOTER //
// ./src/Pages/HomePage/homePageStyles.js